import { Box, Container, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";

export const CONTAINER_DESKTOP_TOP_PADDING = "8px";
export const CONTAINER_DESKTOP_BOTTOM_PADDING = "30px";
export const CONTAINER_MOBILE_BOTTOM_PADDING = "16px";

export default function ResponsiveLayout({ overflowStyle = false, children }) {
  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const customStyle = {
    minHeight: isScreenXs ? "100%" : "max(600px, 100%)",
    paddingLeft: isScreenXs ? "1rem" : "2rem",
    paddingRight: isScreenXs ? "1rem" : "2rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: isScreenXs ? 0 : CONTAINER_DESKTOP_TOP_PADDING,
    paddingBottom: isScreenXs
      ? CONTAINER_MOBILE_BOTTOM_PADDING
      : CONTAINER_DESKTOP_BOTTOM_PADDING,
    backgroundColor: "#fff",
  };

  const customOverflowStyle = {
    boxShadow: "0px 15px 30px -10px #4242",
    // borderBottomLeftRadius: customBorderRadius.paper,
    // borderBottomRightRadius: customBorderRadius.paper,
  };

  return (
    <Box height={"100%"} maxWidth={"504px"}>
      <Container
        maxWidth={false}
        style={
          overflowStyle
            ? { ...customStyle, ...customOverflowStyle }
            : { ...customStyle }
        }
      >
        {children}
      </Container>
    </Box>
  );
}
